export default __webpack_public_path__ + "static/media/icon-step-five.8881e01c.png";